"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var _material = require("@mui/material");
const styles = theme => ({
  card: {
    overflow: 'hide'
  },
  progress: {
    margin: theme.spacing.unit * 2
  }
});
const Loading = _ref => {
  let {
    loadingSt,
    classes
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.Dialog, {
    open: loadingSt
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.card
  }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, {
    className: classes.progress
  })));
};
const mapStateToProps = (state, props) => (
// eslint-disable-line
{
  loadingSt: state.loading
});
const mapDispatchToProps = dispatch => (0, _redux.bindActionCreators)({}, dispatch);
Loading.propTypes = {
  loadingSt: _propTypes.default.bool.isRequired,
  classes: _propTypes.default.object.isRequired
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withStyles.default)(styles)(Loading));